package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.UMS

/* Deep-Sky Object */
class DSO (
    t: SP_Time,
    raUMS: UMS,
    decUMS: UMS,
    var visMag: Double,
    var dsoType: String,
    var mesNum: Int,
    name: String

) : CelestialBody(
    UMS.hourMinSecToDecimalDegrees(raUMS.toString()),
    UMS.unitMinSecToDecimal(decUMS),
    name) {

    var mesName: String = ""
        get(){
            return "M$mesNum"
        }

    val DEF_COLOR = SP_Colour(0,255,0,255)

    /** Overrides abstract method in superclass to do nothing.
     * Might in future be used to correct position for proper motion,
     * precession etc.  */
    override fun recalculateEquatorialCoordinates(time: SP_Time) {

    }

    init {

        recalculateEquatorialCoordinates(t)
        recalculateCartesianCoordinates(t)

        this.rgbColour = DEF_COLOR
        this.name = "${this.mesName} $name" //${getRA_HMSString(3)} ${getDec_DMSString(3)}"
        this.abbrevName = this.mesName
    }
}